
import ApiCall from './ApiCall';
import { printConsole } from '../navigator/RouteConstants';
import { ApiResponse } from '../appojo/responsemodel/ApiResponse';

const requestBodyApi = async (input, endpointPath, isConnected, lang) => {
    if (isConnected) {
        input.requestFrom = window.navigator.platform;
        printConsole('REQYEST INPUT: ' + JSON.stringify(input));

        const result = await ApiCall.post(endpointPath, input)
            .then(function (response) {
                const result = new ApiResponse();
                result.status = 0;
                result.data = response.data;
                printConsole('API Response:  ' + 'enpoint: ' + endpointPath + ' \n' + JSON.stringify(result));
                return result;
            }).catch(function (error) {
                printConsole('API Error common:  ' + 'enpoint: ' + endpointPath + ' ' + JSON.stringify(error))
                const result = new ApiResponse();
                result.status = 1;
                result.error = error;
                return result;
            });
        return result;
    } else {
        const result = new ApiResponse();
        result.status = 2;
        result.message = 'internetcheck'
        return result;
    }
}

export default requestBodyApi;